import TopMenu from "../../../TopMenu";
import MainDashboardLayout from "../../../../../Layout/MainDashboardLayout";
import DocumentationSidebar from "../../../../../Layout/DocumentationSidebar";
import React, { useState, useEffect, useRef } from "react";
import { Box } from "@mui/material";
import { get } from "../../../../../utils/api";
import { companyId } from "../../../../../utils/companyId";
import TableDocument from "../../../TableDocument";
import FilterModal from "../../../../../Components/Common/FilterModal";
import Unauthorized from "../../../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../../../context/AuthContext";

const Main = () => {
  const { user } = useUser();

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const [selectedOption, setSelectedOption] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isShortContent, setIsShortContent] = useState(false);
  const [selectedFacility, setSelectedFacility] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit] = useState(10); // Number of items per page
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [errors, setErrors] = useState({});
  const [selectedMonth, setSelectedMonth] = useState(""); // Stores the selected month
  const [selectedYear, setSelectedYear] = useState(""); // Stores the selected year
  const [uniqueValues, setUniqueValues] = useState({});
  const [filterObj, setFilterObj] = useState({});
  const [filterOptions, setFilterOptions] = useState({});
  const [columnWidth, setcolumnWidth] = useState(
    user?.companyAdmin
          ? "12% 14% 14% 14% 18% 16% 8%"
          : "12% 20% 16% 20% 18% 10%"
  );
  const [url, setUrl] = useState(
    "/renewable-energy-export-avoidance/documents"
  );
  const [Doc, SetDoc] = useState([]);
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });

  useEffect(() => {
    fetchData();
  }, [
    page,
    rowsPerPage,
    searchQuery,
    url,
    fromDate,
    toDate,
    selectedFacility,
    fromDate,
    toDate,
  ]);

  const fetchData = async (filters = filterObj) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page, // Add the current page
        limit: rowsPerPage, // Add the number of rows per page
        sortField: sortConfig.key, // Sort configuration
        sortOrder: sortConfig.direction,
        company: companyId,
        createdBy: companyId,
        search: searchQuery,
        facilityList: selectedFacility.join(","),
      }).toString();
      const response = await get(
        `/scope4${url}?${queryParams}&startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}`
      );
      setData(response.data.data); // Update the user list
      SetDoc(response.data.data);
      setTotalPages(response.data.totalPages); // Update total pages for pagination
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const toggleData = [
    {
      title: "Avoidance from Renewable Energy Export",
      url: "/renewable-energy-export-avoidance/documents",
    },
    {
      title: "Low-carbon Product Use / Cleaner Alternatives",
      url: "/lower-carbon-product/documents",
    },
  ];

  const heading = [
    {
      title: "Entry Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      key: "consumptionPeriod",
      title: "Month of energy export",
    },
    {
      title: "Importer",
      key: "importer",
    },
    {
      title: "Type of renewable energy",
      key: "typeOfRenewableEnergy",
    },
    {
      title: "Energy exported (kWh)",
      key: "energyExported",
    },
  ].filter(Boolean);

  const heading2 = [
    {
      title: "Entry Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      key: "consumptionPeriod",
      title: "Month of Product Sold",
    },
    {
      title: "Product name",
      key: "productName",
    },
    {
      title: "Quantity sold",
      key: "quantitySold",
    },
    {
      title: "Unit of sold product",
      key: "unit",
    },
  ].filter(Boolean);

  const [toggleHeding, SetHeading] = useState(heading);
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const tableContainerRef = useRef(null); // Reference to the table container

  const fetchUniqueValues = async () => {
    try {
      const response = await get(`/scope4${url}`);
      const data = response.data.data;

      const uniqueImporter = [
        ...new Set(
          data.map((el) => el.importer).filter(Boolean) // Filter out undefined values
        ),
      ];
      const uniqueTypeOfRenewableEnergy = [
        ...new Set(
          data.map((el) => el.typeOfRenewableEnergy).filter(Boolean) // Filter out undefined values
        ),
      ];
      const uniqueProductName = [
        ...new Set(
          data.map((el) => el.productName).filter(Boolean) // Filter out undefined values
        ),
      ];

      setFilterOptions({
        importer: uniqueImporter,
        typeOfRenewableEnergy: uniqueTypeOfRenewableEnergy,
        productName: uniqueProductName,
      });
      return {
        importer: uniqueImporter,
        typeOfRenewableEnergy: uniqueTypeOfRenewableEnergy,
        productName: uniqueProductName,
      };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  const filterData = [
    { title: "Entry Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Month of energy export",
      type: "date",
      key: "consumptionPeriod",
      value: [],
    },
    {
      title: "Importer",
      type: "option",
      key: "importer",
      value: filterOptions.importer,
    },
    {
      title: "Type of renewable energy",
      type: "option",
      key: "typeOfRenewableEnergy",
      value: filterOptions.typeOfRenewableEnergy,
    },
  ];

  const filterData2 = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Month of Product Sold",
      type: "date",
      key: "consumptionPeriod",
      value: [],
    },
    {
      title: "Product name",
      type: "option",
      key: "productName",
      value: filterOptions.productName,
    },
  ];

  const handleFilterChange = (newFilterObj) => {
    if (selectedOption === "Renewable Energy Exports") {
      setFilterObj((prev) => ({
        ...prev,
        ...newFilterObj,
      }));
    } else {
      setFilterObj((prev) => ({
        ...prev,
        ...newFilterObj,
      }));
    }

    console.log("Applied Filters:", newFilterObj);
  };

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height

      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 3);
    }
  }, [data]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleToggle = (option, url) => {
    setSelectedOption(option);
    setUrl(url);
    SetHeading(toggleData?.[0]?.title === option ? heading : heading2);
    setcolumnWidth(
      toggleData?.[0]?.title === option
        ? user?.companyAdmin
          ? "12% 14% 14% 14% 18% 16% 8%"
          : "12% 20% 16% 20% 18% 10%"
        : user?.companyAdmin
        ? "12% 15% 13% 16% 13% 19% 8%"
        : "12% 17% 18% 18% 22% 8%"
    );
  };

  useEffect(() => {
    setSelectedOption(toggleData?.[0].title);
    setUrl(toggleData?.[0].url);
  }, []);

  return (
    <MainDashboardLayout sidebar={<DocumentationSidebar />}>
      <Unauthorized requiredModule="Documentation | Scope 4 | Carbon Avoidance">
        <>
          <TopMenu
            {...{
              setDrawerFilterOpen: setIsFilterModalOpen,
              selectedMonth,
              setSelectedMonth,
              selectedYear,
              setSearchQuery,
              setSelectedYear,
              selectedOption,
              handleToggle,
              filterApplied: isFilterModalOpen,
              toggleData,
              fromDate,
              setFromDate,
              toDate,
              setToDate,
              selectedFacility,
              setSelectedFacility,
            }}
            heading={"Carbon Avoidance"}
          />
          <Box
            sx={{
              backgroundColor: "#ededed",
            }}
          >
            <TableDocument
              data={Doc}
              totalPages={totalPages}
              headers={toggleHeding}
              columnWidth={columnWidth}
              tableContainerRef={tableContainerRef}
            />
          </Box>
          <FilterModal
            isOpen={isFilterModalOpen}
            onClose={() => setIsFilterModalOpen(false)}
            filters={
              selectedOption === "Renewable Energy Exports"
                ? filterData
                : filterData2
            }
            onFilterChange={handleFilterChange}
            title="Filter"
          />
        </>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default Main;
